import React, { useState } from 'react';
import TestSeriesCard from "../TestSeriesCard/TestSeriesCard";
import NoData from "../common/Nodata/noData";
import './testSeriesList.scss';
import '../common/cardView.scss';
import TestSeriesLoader from "../common/loaders/TestSeriesLoader";
import useTranslations from "examsbook-react-sdk/custom-hooks/useTranslations";
import CTabs from "../../components/Tabs/CTabs";
import AppBar from '@material-ui/core/AppBar';
import DashboardIcon from '@material-ui/icons/Dashboard';
import MenuBookIcon from '@material-ui/icons/MenuBook';
// import useSubExamList from "examsbook-react-sdk/custom-hooks/useSubExamList";
import { useNavigate } from "react-router-dom";

function TestSeriesList(props) {
    const t = useTranslations();
    const navigate = useNavigate();
    const { handleTabChange, testSeriesList, testSeriesLoading } = props;
    const [ selectedTab, setSelectedTab ] = useState(1);

    function handleTabMenu(event, value) {
        setSelectedTab(value);
    }

    let tabBarList = [ {
        label: t('dashboard'),
        ref: 'dashboard',
        icon: <DashboardIcon/>
    }, {
        label: t('test_series'),
        ref: 'mytest',
        icon: <MenuBookIcon/>
    } ];

    function renderList() {
        if (selectedTab === 0) {
            navigate('/my-app/');
        }
        return (
            <React.Fragment>
                {selectedTab === 1 &&
                <>{
                    testSeriesList && testSeriesList.length > 0 ?
                        <div className="card-view test-series test-series-tabs">
                            {
                                testSeriesList.map((data, index) => {
                                    return (
                                        <TestSeriesCard key={index} testData={data}/>
                                    );
                                })
                            }
                        </div>
                        :
                        <NoData message={t('no_test-series_available_for_his_exam')} handleTabChange={handleTabChange}/>
                }
                </>
                }

                {props.showFooter && <div className="dashboard-mobile-view">
                    <div className={'mock-tabs'}>
                        <AppBar position="static" className="tabs">
                            <CTabs nav={tabBarList} setActiveTab={selectedTab} handleTabChange={handleTabMenu}/>
                        </AppBar>
                    </div>
                </div>}
            </React.Fragment>
        );
    }

    function renderLoader() {
        //we will show three cards to fill this space.
        return (
            <div className="card-view test-series">
                <TestSeriesLoader/>
                <TestSeriesLoader/>
                <TestSeriesLoader/>
                <TestSeriesLoader/>
            </div>
        );
    }

    return (
        <React.Fragment>
            {
                !testSeriesLoading ? renderList() : renderLoader()
            }
        </React.Fragment>
    );
}

export default TestSeriesList;
